import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  data () {
    return {
      textSearch: '',
      form: {
        name: '',
        gender: '',
        birthdate: null,
        address: '',
        email: '',
        tel: '',
        note: '',
        checkAutoSelected: true,
      },
      originalForm: null,
      bindClass: {
        name: null,
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null, // Only for `v-date-picker`
        dayPopover: null, // Only for `v-date-picker`
      },
    }
  },
  computed: {
    ...mapGetters({
      customer_id: 'getPosSelectedCustomerId',
      customers: 'getCustomers',
      dateformat: 'getDateFormat',
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // selected table_number
    }),
    dataSet () {
      var data = { name: this.form.name }
      var contacts = []

      if (this.form.gender) data['gender'] = this.form.gender
      if (this.form.birthdate) data['birthdate'] = this.form.birthdate.toISOString()
      if (this.form.address) data['address'] = this.form.address
      if (this.form.note) data['note'] = this.form.note

      if (this.form.email) {
        contacts.push({
          platform: 'email',
          source: this.form.email,
        })
      }
      if (this.form.tel) {
        contacts.push({
          platform: 'tel',
          source: this.form.tel,
        })
      }

      if (contacts.length > 0) {
        data['contacts'] = contacts
      }

      return data
    },
    isValidForm () {
      if (this.form.name.trim().length == 0) {
        this.bindClass.name = 'is-invalid'
        return false
      } else {
        this.bindClass.name = null
        return true
      }
    },
    searchResults () {
      let value = this.textSearch.toLowerCase()
      return this.customers.filter(customer => customer.customer_name.toLowerCase().search(value) >= 0)
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
      'setPosSelectedCustomerId',
      'insertCustomer',
      'setCustomIdForQueueAndTable',
      'clearPosSelectedCustomerId',
    ]),
    onDeselectCustomer() {
      this.clearPosSelectedCustomerId({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
      this.setPosSection('choose-product')
    },
    onSelectedCustomer ({ customer_id, customer_new }) {
      this.setPosSelectedCustomerId({
        customer_id,
        customer_new,
      })
      this.setCustomIdForQueueAndTable()
      this.setPosSection('choose-product')
    },
    openModal () {
      $('#createModal').modal('show')
    },
    closeModal () {
      let that = this
      $('#createModal').modal('hide').on('hidden.bs.modal', function () {
        that.clearForm()
      })
    },
    async save () {
      if (!this.isValidForm) {
        this.$refs.name.focus()
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      let res = await this.insertCustomer(this.dataSet)

      if (res.success) {
        // get customers
        await this.$store.dispatch('getCustomers')
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: this.dataSet.name }),
          color: 'success',
          icon: 'cloud',
        })
        // close modal
        this.closeModal()
        // loading finish
        this.showFinish(this.$Progress)
        // auto selected
        if (this.form.checkAutoSelected) {
          this.onSelectedCustomer({
            customer_id: res.data.customer_id,
            customer_new: true,
          })
        }
      }
    },
    clearForm () {
      let that = this
      that.form = _.cloneDeep(that.originalForm)
      setTimeout(() => {
        that.bindClass.name = null
      }, 10)
    },
  },
  watch: {
    'form.name': {
      handler: function (after, before) {
        this.isValidForm
      },
      deep: true,
    },
  },
  created: function () {
    // set date format
    this.formats.input = [this.dateformat]
    this.formats.dayPopover = this.dateformat

    // set original form
    this.originalForm = _.cloneDeep(this.form)
  },
  mounted: function () {
    // set popup modal
    this.setModal('#createModal')
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/customerList.js